import Avatar from 'react-avatar';
import { RequestLoading } from 'views/components/CommonPages';
import logo from '../../assets/img/saw-logo.png';
import { getPublicRegistrarAvatarURL } from 'utils/handler';
import agent1Avi from "../../assets/img/agents/agent1.png"
import agent2Avi from "../../assets/img/agents/agent2.png"
import agent3Avi from "../../assets/img/agents/agent3.png"
import agent4Avi from "../../assets/img/agents/agent4.png"
import downArrow from "../../assets/img/down-arrow.svg"
import plus from '../../assets/img/plus.svg';
import { useEffect, useState } from 'react';

const images = [agent1Avi, agent2Avi, agent3Avi, agent4Avi];

const reportCardData = [
    {
        reportHeading: "20",
        reportDescription: "Years of Experience"
    },
    {
        reportHeading: "1000+",
        reportDescription: "Domain Transactions"
    },
    {
        reportHeading: "37%",
        reportDescription: "Savings on Average"
    }
]

interface RegistrarVariant2Props {
    registrarDetails: any
    domainName: string
    learnMore: () => void
}

export const RegistrarVariant2: React.FC<RegistrarVariant2Props> = ({ registrarDetails, domainName, learnMore }): JSX.Element => {
    const [detailsExpanded, setDetailsExpanded] = useState(false)
    const [randomImage, setRandomImage] = useState('');

    useEffect(() => {
        setRandomImage(images[Math.floor(Math.random() * images.length)]);
    }, []);

    return (
        <div className='registrar-variant-1 registrar-variant-2'>

            <div className="saw_registrar_logo_start_screen">
                {registrarDetails?.image || registrarDetails?.name ? (
                    <Avatar className="edit-user-image " textSizeRatio={3} src={getPublicRegistrarAvatarURL(registrarDetails?.UID, registrarDetails?.image)} name={registrarDetails.name} />
                ) : (
                    <div className=" d-flex align-items-center text-right ">
                        <RequestLoading color="#031B4E" height={20} width={3} />
                    </div>
                )}
                <div className='partner-text'>
                    In partnership with
                </div>
                <img src={plus} className="fa-plus-cus mx-3" alt="Img"></img>
                <div className="">
                    <img src={logo} className="saw-logo" alt="Img"></img>
                </div>
            </div>

            <div className="sub-title-wrapper my-4">
                <div className="sub-title">We've teamed up with the experts at Saw.com to help you buy that domain! </div>
            </div>

            <div className="domain-details">
                <div className="domain-name">
                    <div className='name'>
                        {domainName}
                    </div>
                    <div className='taken'>
                        Domain Taken
                    </div>
                </div>

                <div className="assist-you">
                    <div className="avatar">
                        <img src={randomImage} alt="avatar" />
                    </div>
                    <div className="assist-text">
                        We might be able to assist you with that.
                    </div>
                </div>

                <div className="get-started">
                    <button className="get-started-btn" onClick={() => learnMore()}>
                        Get Started
                    </button>
                    <button className="details-btn" onClick={() => { setDetailsExpanded(!detailsExpanded) }}>
                        Details <img src={downArrow} alt="arrow" className='arrow-icon' />
                    </button>
                </div>
            </div>


            {detailsExpanded && <div className={"details-expanded"}>
                <div className="card-head">
                    You get a dedicated domain broker.
                </div>
                <div className="card-desc card-desc-mb">
                    When you choose this service, a dedicated broker will assist you in creating a strategy and setting a budget to help acquire your desired domain.
                </div>

                <div className="card-head">
                    The domain broker negotiates on your behalf.
                </div>
                <div className="card-desc card-desc-mb">
                    The broker communicates directly with the domain owner, working to secure the lowest possible price. (Rest assured, your identity stays confidential.)
                </div>

                <div className="card-head">
                    The domain is safely transferred to your account.
                </div>
                <div className="card-desc">
                    Once the owner agrees to the sale, you pay the negotiated price plus a 20% commission. The domain is then securely transferred to your account, with Saw.com managing every step of the process to ensure a seamless transaction.
                </div>
            </div>}



            <div className="report-cards">
                {reportCardData.map((reportCarddata) => <div className='report-card'>
                    <div className="report-head">{reportCarddata.reportHeading}</div>
                    <div className="report-desc">{reportCarddata.reportDescription}</div>
                </div>)}
            </div>
        </div>
    );
};

export default RegistrarVariant2;
